import { IconButton, Stack, Typography, useTheme } from "@mui/material";
import { CloseIcon } from "components";
import { RecurringTicketFormSection } from "pages/modules/control-center/recurring-tickets/components/RecurringTicketFormSection";
import React from "react";
import { TicketCreationType } from "../CreateTicketDrawer";
import { AdditionalTicketForm } from "./AdditionalTicketForm";
import { ChecklistComponent } from "./ChecklistComponent";
import { TagsComponent } from "./TagsComponent";

type SidebarTabType = "properties" | "tags" | "checklist" | "recurring";
type SidebarProps = {
  title: string;
  onClose: () => void;
  type: SidebarTabType;
  ticketCreationType: TicketCreationType;
  lockMakeRecurringToggle?: boolean;
  createdFrom?: "recurring_tickets" | "ticket_drawer";
};
export const SidebarDetailsComponentWrapper = ({
  title,
  onClose,
  type,
  ticketCreationType,
  lockMakeRecurringToggle = false,
  createdFrom = "ticket_drawer",
}: SidebarProps) => {
  const theme = useTheme();
  return (
    <Stack sx={{ width: "100%", height: "100%" }}>
      <Stack
        sx={{
          flexShrink: 0,
          boxShadow:
            " 0px 2px 4px 0px rgba(0, 0, 0, 0.05), 0px 2px 2px 0px rgba(0, 0, 0, 0.02)",
        }}
      >
        <Stack
          paddingLeft="16px"
          paddingRight="12px"
          paddingY="12px"
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography component={"span"} variant={"h6"}>
            {title}
          </Typography>
          <Stack
            onClick={onClose}
            direction={"row"}
            alignItems={"center"}
            gap="12px"
            sx={{
              cursor: "pointer",
            }}
          >
            <CloseIcon />
          </Stack>
        </Stack>
      </Stack>
      <Stack
        sx={{
          overflowY: "scroll",
          flexGrow: 1,
        }}
      >
        <TabDetailsSection
          type={type}
          ticketCreationType={ticketCreationType}
          lockMakeRecurringToggle={lockMakeRecurringToggle}
          createdFrom={createdFrom}
        />
      </Stack>
    </Stack>
  );
};

const TabDetailsSection = ({
  type,
  ticketCreationType,
  lockMakeRecurringToggle,
  createdFrom = "ticket_drawer",
}: {
  type: SidebarTabType;
  ticketCreationType: TicketCreationType;
  lockMakeRecurringToggle?: boolean;
  createdFrom?: "recurring_tickets" | "ticket_drawer";
}) => {
  switch (type) {
    case "properties":
      return (
        <AdditionalTicketForm
          type={ticketCreationType}
          createdFrom={createdFrom}
        />
      );

    case "tags":
      return <TagsComponent />;

    case "checklist":
      return <ChecklistComponent />;

    case "recurring":
      return (
        <Stack sx={{ p: "16px" }}>
          <RecurringTicketFormSection
            lockToggle={lockMakeRecurringToggle ?? false}
            variant="inline"
          />
        </Stack>
      );

    default:
      return <></>;
  }
};
